import { render, staticRenderFns } from "./ExpansionBarWithForm.vue?vue&type=template&id=51b45df0&"
import script from "./ExpansionBarWithForm.vue?vue&type=script&lang=ts&"
export * from "./ExpansionBarWithForm.vue?vue&type=script&lang=ts&"
import style0 from "./ExpansionBarWithForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VExpandTransition,VForm,VRow})
